import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { useBusinessForm } from '../hooks';
import { BusinessFormContextProvider } from '../context';

interface BusinessFormProps {
  children?: React.ReactNode;
  className?: HTMLFormElement['className'];
  useBusinessFormReturn: ReturnType<typeof useBusinessForm>;
}

/**
 *
 * @deprecated Use ElementsForm from packages/elements/src/UI/components/ElementsForm.tsx in combination with
 * useCreateBusinessForm from  packages/elements/src/Business/hooks/useCreateBusinessForm.ts
 * and useEditBusinessForm from  packages/elements/src/Business/hooks/useEditBusinessForm.ts
 * instead
 */
export const BusinessForm: FC<BusinessFormProps> = ({
  children,
  className,
  useBusinessFormReturn: { onSubmit, formMethods, business, householdID },
}) => {
  return (
    <FormProvider {...formMethods}>
      <BusinessFormContextProvider business={business} householdID={householdID}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
          {children}
        </form>
      </BusinessFormContextProvider>
    </FormProvider>
  );
};
